import type { ViewProps } from '@/components/atomic/atoms/layout/view/typings';
import { generateStylesheetRules } from '@/utils/generate-stylesheet-rules';
import styled, { CSSObject } from '@emotion/styled';

const View = styled.div<ViewProps>(
	({
		$breakpoints,
		$elementStates,
		$height,
		$width,
		$maxWidth,
		$maxHeight,
		$minWidth,
		$minHeight,
		$paddingLeft,
		$paddingRight,
		$paddingTop,
		$paddingBottom,
		$padding,
		$marginLeft,
		$marginRight,
		$marginTop,
		$marginBottom,
		$margin,
		$position,
		$top,
		$right,
		$bottom,
		$left,
		$display,
		$textAlign,
		$transform,
		$border,
		$borderWidth,
		$borderStyle,
		$borderColor,
		$borderRadius,
		$backgroundColor,
		$overflow,
		$overflowX,
		$overflowY,
		$zIndex,
		$borderTop,
		$borderBottom,
		$backdropFilter,
		$opacity,
		$transition,
		$justifyContent,
		$alignItems,
		$visibility,
		$boxShadow,
	}) => {
		const viewProps = {
			$height,
			$width,
			$maxWidth,
			$maxHeight,
			$minWidth,
			$minHeight,
			$paddingLeft,
			$paddingRight,
			$paddingTop,
			$paddingBottom,
			$padding,
			$marginLeft,
			$marginRight,
			$marginTop,
			$marginBottom,
			$margin,
			$position,
			$top,
			$right,
			$bottom,
			$left,
			$display,
			$textAlign,
			$transform,
			$border,
			$borderWidth,
			$borderStyle,
			$borderColor,
			$borderRadius,
			$backgroundColor,
			$overflow,
			$overflowX,
			$overflowY,
			$zIndex,
			$borderTop,
			$backdropFilter,
			$opacity,
			$transition,
			$justifyContent,
			$alignItems,
			$visibility,
			$borderBottom,
			$boxShadow,
		};
		const style: CSSObject = generateStylesheetRules(
			viewProps,
			Object.keys(viewProps),
		);

		if ($breakpoints !== undefined) {
			Object.entries($breakpoints).forEach(([breakpoint, props]) => {
				const breakpointKey = `@media (min-width: ${breakpoint}px)`;

				const nestedStyle: CSSObject = generateStylesheetRules(
					props,
					Object.keys(props),
				);

				if (!style[breakpointKey]) style[breakpointKey] = nestedStyle;
			});
		}

		if ($elementStates !== undefined) {
			Object.entries($elementStates).forEach(([elementState, props]) => {
				const elementStateKey = `&:${elementState}`;

				const nestedStyle: CSSObject = generateStylesheetRules(
					props,
					Object.keys(props),
				);

				if (!style[elementStateKey])
					style[elementStateKey] = nestedStyle;
			});
		}

		return style;
	},
);

export default View;
